export const toneOptions = [
    "Professional",
    "Modern",
    "Creative",
    "Luxury",
    "Friendly",
    "Bold"
];

export const industryOptions = [
    "Education",
    "Real Estate",
    "Ecommerce",
    "Healthcare",
    "Legal",
    "SaaS",
    "Restaurant",
    "Fitness",
    "Beauty",
    "Construction",
    "Home Services",
    "Consulting"
];

export const subIndustryOptionsByIndustry = {
    Education: [
        "Sports Academy",
        "Coaching Institute",
        "School",
        "Online Course"
    ],

    "Real Estate": [
        "Real Estate Portal",
        "Property Agency",
        "Property Developer",
        "Real Estate Advisory"
    ],

    Ecommerce: [
        "Online Store",
        "Fashion Store",
        "Beauty Store",
        "Electronics Store",
        "General Store"
    ],

    Healthcare: [
        "Clinic",
        "Dental Clinic",
        "Medical Practice",
        "Wellness Center"
    ],

    Legal: [
        "Law Firm",
        "Legal Consultant",
        "Corporate Legal",
        "Immigration Lawyer"
    ],

    SaaS: [
        "SaaS Platform",
        "AI Software",
        "CRM Software",
        "Productivity Tool"
    ],

    Restaurant: [
        "Cafe",
        "Restaurant",
        "Cloud Kitchen",
        "Bakery"
    ],

    Fitness: [
        "Gym",
        "Personal Training",
        "Yoga Studio",
        "Sports Training"
    ],

    Beauty: [
        "Salon",
        "Spa",
        "Beauty Clinic",
        "Makeup Studio"
    ],

    Construction: [
        "Construction Company",
        "Interior Design",
        "Architecture Studio"
    ],

    "Home Services": [
        "Local Service Business",
        "Cleaning Service",
        "Repair Service"
    ],

    Consulting: [
        "Business Consulting",
        "Marketing Agency",
        "IT Consulting"
    ]
};

export const ctaOptions = [
    "Contact Us",
    "Book a Call",
    "Request a Quote",
    "Book a Demo",
    "Book an Appointment",
    "Get Started",
    "Shop Now",
    "Send Inquiry",
    "View Portfolio",
    "See Pricing",
    "WhatsApp Now",
    "Download Brochure",
    "Join Now",
    "Book Trial",
    "Reserve Table",
    "Start Free Trial"
];

export const brandStyleOptions = [
    "Premium",
    "Minimal",
    "Corporate",
    "Luxury",
    "Bold",
    "Modern",
    "Friendly",
    "High-Trust",
    "Startup",
    "Creative"
];

export const pricePositioningOptions = [
    "Affordable",
    "Mid-Market",
    "Premium",
    "Luxury"
];

export const goalOptions = [
    "Generate Leads",
    "Book Appointments",
    "Drive Sales",
    "Showcase Portfolio",
    "Build Trust",
    "Brand Awareness",
    "Get Demo Requests",
    "Capture Emails",
    "Promote Service",
    "Launch Product",
    "Drive WhatsApp Inquiries",
    "Increase Phone Calls"
];

export const websiteTypeOptions = [
    { label: "Auto (AI Decide)", value: "" },
    { label: "Property Portal / Listings", value: "real-estate-portal" },
    { label: "Real Estate Company / Advisory", value: "real-estate-company" },
    { label: "Academy / Institute", value: "academy" },
    { label: "Store / Shop", value: "ecommerce" },
    { label: "SaaS Product / Platform", value: "saas" },
    { label: "Clinic / Healthcare Center", value: "healthcare" },
    { label: "Law Firm / Legal Practice", value: "legal" },
    { label: "Restaurant / Cafe", value: "restaurant" },
    { label: "Fitness / Gym", value: "fitness" },
    { label: "Beauty / Salon", value: "beauty" },
    { label: "Service Business", value: "service" }
];

export const websiteModeOptions = [
    { label: "Auto (AI Decide)", value: "" },
    { label: "Search First", value: "search-first" },
    { label: "Lead First", value: "lead-first" },
    { label: "Conversion First", value: "conversion-first" },
    { label: "Program First", value: "program-first" },
    { label: "Product First", value: "product-first" },
    { label: "Trust First", value: "trust-first" },
    { label: "Authority First", value: "authority-first" },
    { label: "Booking First", value: "booking-first" }
];

export const entityTypeOptions = [
    { label: "Auto (AI Decide)", value: "" },
    { label: "Properties / Listings", value: "listings" },
    { label: "Localities / Areas", value: "localities" },
    { label: "Programs / Courses", value: "programs" },
    { label: "Coaches / Trainers", value: "coaches" },
    { label: "Products", value: "products" },
    { label: "Collections", value: "collections" },
    { label: "Services", value: "services" },
    { label: "Features / Modules", value: "features" },
    { label: "Pricing / Plans", value: "pricing" },
    { label: "Treatments", value: "treatments" },
    { label: "Doctors", value: "doctors" },
    { label: "Practice Areas", value: "practiceAreas" },
    { label: "Team", value: "team" },
    { label: "Menu Items", value: "menu" },
    { label: "Gallery", value: "gallery" }
];

export const locationFocusOptions = [
    { label: "Auto (AI Decide)", value: "" },
    { label: "Local", value: "local" },
    { label: "Regional", value: "regional" },
    { label: "National", value: "national" },
    { label: "Global", value: "global" }
];

export const websiteFeelOptions = [
    { label: "Auto (AI Decide)", value: "" },
    { label: "Modern", value: "modern" },
    { label: "Premium", value: "premium" },
    { label: "Clean", value: "clean" },
    { label: "Bold", value: "bold" },
    { label: "Friendly", value: "friendly" },
    { label: "Luxury", value: "luxury" },
    { label: "Warm", value: "warm" }
];

export const getRecommendedPages = (
    industry,
    subIndustry,
    businessModel = "",
    primaryWebsiteMode = ""
) => {
    const text = `${industry} ${subIndustry} ${businessModel} ${primaryWebsiteMode}`.toLowerCase();

    if (
        text.includes("real estate") ||
        text.includes("property") ||
        text.includes("portal") ||
        text.includes("listing") ||
        text.includes("search-first")
    ) {
        if (text.includes("portal")) {
            return ["Home", "Listings", "Localities", "About", "Contact"];
        }

        return ["Home", "Listings", "Services", "About", "Contact"];
    }

    if (
        text.includes("sports") ||
        text.includes("academy") ||
        text.includes("training") ||
        text.includes("education") ||
        text.includes("school") ||
        text.includes("course") ||
        text.includes("program-first")
    ) {
        return ["Home", "Programs", "Coaches", "Admissions", "Contact"];
    }

    if (
        text.includes("ecommerce") ||
        text.includes("e-commerce") ||
        text.includes("store") ||
        text.includes("shop") ||
        text.includes("product-first")
    ) {
        return ["Home", "Products", "Collections", "About", "Contact"];
    }

    if (
        text.includes("saas") ||
        text.includes("software") ||
        text.includes("platform") ||
        text.includes("crm") ||
        text.includes("automation")
    ) {
        return ["Home", "Features", "Pricing", "About", "Contact"];
    }

    if (
        text.includes("healthcare") ||
        text.includes("clinic") ||
        text.includes("medical") ||
        text.includes("dental") ||
        text.includes("doctor") ||
        text.includes("wellness")
    ) {
        return ["Home", "Treatments", "Doctors", "About", "Contact"];
    }

    if (
        text.includes("legal") ||
        text.includes("law") ||
        text.includes("law firm") ||
        text.includes("advocate") ||
        text.includes("attorney")
    ) {
        return ["Home", "Practice Areas", "Team", "About", "Contact"];
    }

    if (
        text.includes("restaurant") ||
        text.includes("cafe") ||
        text.includes("cloud kitchen") ||
        text.includes("bakery")
    ) {
        return ["Home", "Menu", "Gallery", "About", "Contact"];
    }

    if (
        text.includes("fitness") ||
        text.includes("gym") ||
        text.includes("yoga") ||
        text.includes("personal training")
    ) {
        return ["Home", "Programs", "Trainers", "Memberships", "Contact"];
    }

    if (
        text.includes("beauty") ||
        text.includes("salon") ||
        text.includes("spa") ||
        text.includes("makeup")
    ) {
        return ["Home", "Services", "Gallery", "About", "Contact"];
    }

    return ["Home", "About", "Services", "Contact"];
};